import { Button, ButtonSize, ButtonVariant, Show } from "shared/components";
import { scrollToIncomeSource } from "../../../helpers";
import { HugeiconsIcon } from "@hugeicons/react";
import { AlertCircleIcon } from "@hugeicons-pro/core-solid-rounded";

export const IncomeSourceWarning = ({
  incomeId,
  incomeName,
  statusMessage,
  titleOverride,
  description,
  status
}: {
  incomeId: number;
  incomeName: string;
  statusMessage?: string;
  titleOverride?: string;
  description?: string;
  status?: "Rejected" | "Warning" | "Accepted";
}) => {
  return (
    <div className="flex w-full justify-between flex-wrap md:flex-nowrap gap-y-2 items-start">
      <div className="flex items-center gap-3">
        <HugeiconsIcon
          icon={AlertCircleIcon}
          size={20}
          className={
            status === "Warning" ? "text-warning-500" : "text-danger-500"
          }
        />
        <div className="flex flex-col gap-1 items-start">
          <p className="text-content-1000 font-medium">
            {titleOverride ? (
              titleOverride
            ) : (
              <>
                Income source &ldquo;
                <span className="font-bold">{incomeName}</span>
                &rdquo; {statusMessage}
              </>
            )}
          </p>
          <Show if={description}>
            <p className="text-content-400 font-normal text-sm">
              {description}
            </p>
          </Show>
        </div>
      </div>

      <Button
        variant={ButtonVariant.BASE}
        size={ButtonSize.SM}
        onClick={() => scrollToIncomeSource(incomeId)}
      >
        Review
      </Button>
    </div>
  );
};
